type matcher = (entry: any[]) => boolean;

// a little function to help us with reordering the result
export function reorder<T>(
  list: T[],
  startIndex: number,
  endIndex: number
): T[] {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

const defaultMatchers: { [key: string]: matcher } = {
  avatar: (entry: string[]) => entry[0] == "avatarUrl",
  vzbl: (entry: string[]) => entry[0].toLowerCase().startsWith("vzbl"),
  hidden: (entry: string[]) =>
    entry[0].startsWith("_") || entry[0].includes("__raw"),
  links: (entry: string[]) =>
    typeof entry[1] === "string" &&
    entry[1].slice(0, 8) === "https://" &&
    entry[0] != "avatarUrl",
};

export const coerceArray = (value: any) => {
  if (Array.isArray(value)) return value;
  if (value == undefined) return [];
  return [value];
};

export const splitAttributes = (
  properties: { [key: string]: string[] },
  sorted = true,
  matchers: { [key: string]: matcher } = defaultMatchers
): { [key: string]: string[][] } => {
  const result: { [key: string]: string[][] } = {};
  Object.entries(matchers).forEach(([key, matcher]) => {
    /* eslint-disable-next-line unicorn/no-array-callback-reference */
    result[key] = Object.entries(properties).filter(matcher) as string[][];
  });
  result["other"] = Object.entries(properties).filter(
    /* eslint-disable-next-line unicorn/no-array-callback-reference */
    (entry) => !Object.values(matchers).some((matcher) => matcher(entry))
  ) as string[][];
  if (sorted) {
    Object.entries(result).forEach(([key, value]) => {
      result[key] = stringSort(value);
    });
  }
  return result;
};

export const stringSort = (values: string[][]) => {
  return values.sort(([a], [b]) =>
    a.toLowerCase().localeCompare(b.toLowerCase())
  );
};

export function setContains<T>(superSet: Set<T>, subSet: Set<T>) {
  return [...subSet].every((val) => superSet.has(val));
}
